






























































import AddFrameCommand from "@/components/AddFrameCommand.vue";
import { computeAddFrameCommandContainerSize, CustomEventTypes, getActiveContextMenu, getAddFrameCmdElementUID, getCommandsContainerUID, getCommandsRightPaneContainerId, getCurrentFrameSelectionScope, getEditorMiddleUID, getMenuLeftPaneUID, handleContextMenuKBInteraction, hiddenShorthandFrames, notifyDragEnded } from "@/helpers/editor";
import { useStore } from "@/store/store";
import { AddFrameCommandDef, AllFrameTypesIdentifier, CaretPosition, defaultEmptyStrypeLayoutDividerSettings, FrameObject, PythonExecRunningState, SelectAllFramesFuncDefScope, StrypePEALayoutMode, StrypeSyncTarget } from "@/types/types";
import $ from "jquery";
import Vue from "vue";
import browserDetect from "vue-browser-detect-plugin";
import { mapStores } from "pinia";
import { getFrameSectionIdFromFrameId } from "@/helpers/storeMethods";
import scssVars  from "@/assets/style/_export.module.scss";
import { isMacOSPlatform } from "@/helpers/common";

import {Splitpanes, Pane, PaneData} from "splitpanes";
import PythonExecutionArea from "@/components/PythonExecutionArea.vue";
import {getPEAConsoleId, getPEAGraphicsDivId, getPEATabContentContainerDivId, getPEAComponentRefId, getPEAControlsDivId} from "@/helpers/editor";



export default Vue.extend({
    name: "Commands",

    components: {
        AddFrameCommand,
        
        
        Splitpanes, Pane,
        PythonExecutionArea, 
        
    },

    data: function () {
        return {
            scssVars, // just to be able to use in template
            showProgress: false,
            progressPercent: 0,
            uploadThroughUSB: false,
            frameCommandsReactiveFlag: false, // this flag is only use to allow a reactive binding when the add frame commands are updated (language),
            lastProjectSavedDateTooltip: "", // update on a mouse over event (in getLastProjectSavedDateTooltip)
            
            isExpandedPEA: false, // flag indicating whether the Python Execution Area is expanded (to update the UI parts accordingly)
            hasPEAExpanded: false, // flag indicating whether the Python Execution Area *has ever been* expanded
            peaMountedEventName: CustomEventTypes.pythonExecAreaMounted,
            commandSplitterPane1MinSize: 0, // to be adjusted after the component is mounted
            commandSplitterPane2MinSize: 0, // to be adjusted after the component is mounted
            commandsSplitterPane2Size: 0, // to be adjused after the component is mounted
            isCommandsSplitterChanged: false,
            
        };
    },

    

    computed: {
        ...mapStores(useStore),

        projectName(): string {
            // When the project is updated, we reflect this into the HTML meta-data.
            document.title = "Strype - " + this.appStore.projectName;
            return this.appStore.projectName;
        },

        isEditorContentModifiedFlag(): boolean {
            return (this.appStore.isEditorContentModified);
        },

        isProjectFromGoogleDrive(): boolean {
            return this.appStore.syncTarget == StrypeSyncTarget.gd;
        },

        isProjectFromFS(): boolean {
            return this.appStore.syncTarget == StrypeSyncTarget.fs;
        },
        
        isProjectNotSourced(): boolean {
            return this.appStore.syncTarget == StrypeSyncTarget.none;
        },
        
        
        peaComponentRefId(): string {
            return getPEAComponentRefId();
        },
        

        
        commandsContainerUID(): string {
            return getCommandsContainerUID();
        },

        isEditing(): boolean {
            return this.appStore.isEditing;
        },

        addFrameCommands(): Record<string, AddFrameCommandDef[]> {
            // Just use the flag data to bind this computed property to the flag, so that when the frame commands are changed, we can update the UI
            this.frameCommandsReactiveFlag;

            //We retrieve the add frame commands associated with the current frame 
            //if the frame is enabled, we always check, if it is disabled we return no frame when caret is body, and check when caret is below
            const currentFrame: FrameObject = this.appStore.getCurrentFrameObject;
            if(currentFrame.isDisabled && ((currentFrame.caretVisibility === CaretPosition.body) ? true : !this.appStore.canAddFrameBelowDisabled(currentFrame.id))){
                return {};
            }

            return this.appStore.generateAvailableFrameCommands(this.appStore.currentFrame.id, this.appStore.currentFrame.caretPosition);
        },

        progressPercentWidthStyle(): string {
            return "width: " + this.progressPercent + "%;";
        },
    },

    created() {
        if(this.appStore.showKeystroke){
            window.addEventListener(
                "dblclick",
                () => {
                    (document.getElementById("keystrokeSpan") as HTMLSpanElement).textContent = "[double click]";
                    //leave the message for a short moment only
                    setTimeout(()=> (document.getElementById("keystrokeSpan") as HTMLSpanElement).textContent = "", 1000);    
                }
            );

            window.addEventListener(
                "mousedown",
                (event: MouseEvent) => {
                    let mouseButton = "unknown mouse click";
                    switch(event.button){
                    case 0:
                        mouseButton = "left click";
                        break;
                    case 1:
                        mouseButton = "middle click";
                        break;
                    case 2:
                        mouseButton = "right click";
                        break;
                    }
                    (document.getElementById("keystrokeSpan") as HTMLSpanElement).textContent = "["+mouseButton+"]";
                    //leave the message for a short moment only
                    setTimeout(()=> (document.getElementById("keystrokeSpan") as HTMLSpanElement).textContent = "", 1000);    
                }
            );
        }

        window.addEventListener(
            "keydown",
            (event: KeyboardEvent) => {
                if (event.repeat && !(!this.appStore.isEditing &&  ["ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight", "Tab", "Home", "End"].includes(event.key))) {
                    // For all keys except Arrows when not editing, ignore all repeated keypresses, only process the initial press:
                    
                    // For enter, prevent repeat as this can cause issues, e.g. repeated triggering of the Run button on Mac:
                    if (event.key.toLowerCase() == "enter") {
                        event.preventDefault();
                    }
                    return;
                }

                const eventKeyLowCase = event.key.toLowerCase();
                const isPythonExecuting = ((this.appStore.pythonExecRunningState ?? PythonExecRunningState.NotRunning) != PythonExecRunningState.NotRunning);
                const isEditing = this.appStore.isEditing;
                const isDraggingFrames = this.appStore.isDraggingFrame;
                
                //if we requested to log keystroke, display the keystroke event in an unobtrusive location
                //when editing, we don't show the keystroke for basic keys (like [a-zA-Z0-1]), only those whose key value is longer than 1
                if(this.appStore.showKeystroke && (!isEditing || event.key.match(/^.{2,}$/))){
                    (document.getElementById("keystrokeSpan") as HTMLSpanElement).textContent = "["+event.key+"]";
                    //leave the message for a short moment only
                    setTimeout(()=> (document.getElementById("keystrokeSpan") as HTMLSpanElement).textContent = "", 1000);         
                }

                // If a modal is open, we let the event be handled by the browser
                if(this.appStore.isModalDlgShown){
                    return;
                }

                if(!isDraggingFrames && (event.ctrlKey || event.metaKey)) {
                    // Undo-redo
                    if(eventKeyLowCase === "z" || eventKeyLowCase === "y"){
                        if(!isPythonExecuting) {
                            this.appStore.undoRedo((eventKeyLowCase === "z"));
                        }
                        event.preventDefault();
                        return;
                    }          
                    
                    // Select all - we only need to interfere with the frame selection (i.e. when not editing slots).
                    // Selecting all frames selects all the frames of the current frame container (e.g. "imports" or "main code")
                    // and position the caret at the bottom of the selection.
                    // For function definitions, however, we use a slightly different approach: we have "intermediate" selection steps:
                    // function's body > whole function > all functions (that last case is equivalent to as mentioned for "imports" and "main code")
                    if(eventKeyLowCase === "a" && !isEditing){ 
                        if(getActiveContextMenu() == null && !this.appStore.isAppMenuOpened){
                            const frameContainerId = getFrameSectionIdFromFrameId(this.appStore.currentFrame.id);
                            // If a selection already exists, we clear it, after checking where we are at in the case of function defs (cf. below)
                            const currentFrameSelection = getCurrentFrameSelectionScope();
                            this.appStore.unselectAllFrames();
                            switch(currentFrameSelection){
                            case SelectAllFramesFuncDefScope.frame:
                            case SelectAllFramesFuncDefScope.functionsContainerBody:
                                // In imports or main code. Or in function definitions with some functions selected, or inside the function defs container.
                                // Position the frame cursor inside the body of the frame container
                                this.appStore.setCurrentFrame({id: frameContainerId, caretPosition: CaretPosition.body});
                                // And select all the children frame of the container (if any...)
                                this.appStore.frameObjects[frameContainerId].childrenIds.forEach(() => {
                                    this.appStore.selectMultipleFrames("ArrowDown");
                                });     
                                break;
                            case SelectAllFramesFuncDefScope.none:
                                // In a function definition with no frame selected or some frames inside a function body (not all).
                                // We select all the frames of the function's body.
                                {
                                    let functionDefFrameId = 0, currentFrameId = this.appStore.currentFrame.id, foundFunctionDefFrame = false;
                                    if(this.appStore.frameObjects[currentFrameId].frameType.type == AllFrameTypesIdentifier.funcdef){
                                        // If we are in the body of the function definition (just inside the body position, not somewhere else)
                                        //then we don't need to look up for the body position as we're already there...
                                        foundFunctionDefFrame = true;
                                        functionDefFrameId = currentFrameId;
                                    }
                                    while(!foundFunctionDefFrame){
                                        functionDefFrameId = this.appStore.frameObjects[currentFrameId].parentId;
                                        foundFunctionDefFrame = (this.appStore.frameObjects[functionDefFrameId].frameType.type == AllFrameTypesIdentifier.funcdef);
                                        currentFrameId = functionDefFrameId;
                                    }
                                    this.appStore.setCurrentFrame({id: functionDefFrameId, caretPosition: CaretPosition.body});
                                    // And select all the children frame of the container (if any...)
                                    this.appStore.frameObjects[functionDefFrameId].childrenIds.forEach(() => {
                                        this.appStore.selectMultipleFrames("ArrowDown");
                                    });    
                                }
                                break;
                            case SelectAllFramesFuncDefScope.belowFunc:
                                // Below a whole function definition, we select that function.
                                this.appStore.selectMultipleFrames("ArrowUp");     
                                // And reposition the caret below for consistency with other select-all conditions
                                this.appStore.setCurrentFrame({id: this.appStore.selectedFrames.at(-1) as number, caretPosition: CaretPosition.below});   
                                break;
                            case SelectAllFramesFuncDefScope.wholeFunctionBody:
                                // In function definitions with function body frames selected.
                                // We select the whole function.
                                {
                                    const functionFrameId = (this.appStore.currentFrame.caretPosition == CaretPosition.body) 
                                        ? this.appStore.currentFrame.id 
                                        : this.appStore.frameObjects[this.appStore.currentFrame.id].parentId; 
                                    this.appStore.setCurrentFrame({id: functionFrameId, caretPosition: CaretPosition.below});
                                    // And select the function going upwards
                                    this.appStore.selectMultipleFrames("ArrowUp");
                                    // And reposition the caret below for consistency with other select-all conditions
                                    this.appStore.setCurrentFrame({id: functionFrameId, caretPosition: CaretPosition.below});    
                                }
                                break;
                            default:                                            
                                break;
                            }
                        }
                        event.preventDefault();
                        return;
                    }
                }
                
                
                // If ctrl-enter/cmd-enter is pressed, make sure we quit the editing (if that's the case) and run the code
                if((event.ctrlKey || event.metaKey) && eventKeyLowCase === "enter" && this.$refs[getPEAComponentRefId()]) {
                    ((this.$refs[getPEAComponentRefId()] as InstanceType<typeof PythonExecutionArea>).$refs.runButton as HTMLButtonElement).focus();
                    ((this.$refs[getPEAComponentRefId()] as InstanceType<typeof PythonExecutionArea>).$refs.runButton as HTMLButtonElement).click();
                    // Need to unfocus to avoid keyboard focus non-obviously remaining with the run button:
                    ((this.$refs[getPEAComponentRefId()] as InstanceType<typeof PythonExecutionArea>).$refs.runButton as HTMLButtonElement).blur();
                    
                    // Don't then process the keypress for other purposes:
                    event.preventDefault();
                    event.stopPropagation();
                    event.stopImmediatePropagation();
                    return;
                }
                

                // If a context menu is currently displayed, we handle the menu keyboard interaction here
                // (note that preventing the event here also prevents the keyboard scrolling of the page)
                if(!isEditing && this.appStore.contextMenuShownId.length > 0 && getActiveContextMenu()){
                    handleContextMenuKBInteraction(event.key);
                    event.stopImmediatePropagation();
                    event.preventDefault();
                    return;
                }

                // Prevent default scrolling and navigation in the editor, except if Turtle is currently running and listening for key events
                // (then we just leave the PEA handling it, see at the end of these conditions for related code)
                if (!isDraggingFrames && !isEditing &&  !(isPythonExecuting && ((this.$refs[getPEAComponentRefId()] as InstanceType<typeof PythonExecutionArea>).$data.isTurtleListeningKeyEvents || (this.$refs[getPEAComponentRefId()] as InstanceType<typeof PythonExecutionArea>).$data.isRunningStrypeGraphics)) &&  ["ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight", "Tab", "Home", "End"].includes(event.key)) {
                    event.stopImmediatePropagation();
                    event.stopPropagation();
                    event.preventDefault();
                    
                    if(this.appStore.ignoreKeyEvent){
                        this.appStore.ignoreKeyEvent = false;
                        return;
                    }
                    
                    if (event.key === "ArrowDown" || event.key === "ArrowUp" ) {
                        if(event.shiftKey){
                            this.appStore.selectMultipleFrames(event.key);
                        }
                        else {
                            // The navigation is "level scope" when the ctrl key is pressed (alt key for macOS)
                            this.appStore.changeCaretPosition(event.key, ((event.ctrlKey && !isMacOSPlatform()) || (event.altKey && isMacOSPlatform())));
                        }
                    }
                    else if(event.key == "Home" || event.key == "End"){
                        // For the "home" and "end" key, we move the blue caret to the first or last position of the current main section the caret is in.
                        // This is overriding the natural browser behaviour that scrolls to the top or bottom of the page (at least with Chrome)
                       
                        // Look for the section we're in
                        const sectionId = getFrameSectionIdFromFrameId(this.appStore.currentFrame.id);
                        // Update the caret to the first/last position within this section
                        const isMovingHome = (event.key == "Home");
                        const isSectionEmpty = (this.appStore.frameObjects[sectionId].childrenIds.length == 0);
                        const newCaretId = (isMovingHome || isSectionEmpty) ? sectionId : this.appStore.frameObjects[sectionId].childrenIds.at(-1) as number;
                        const newCaretPosition = (isMovingHome || isSectionEmpty) ? CaretPosition.body : CaretPosition.below;
                        this.appStore.toggleCaret({id: newCaretId, caretPosition: newCaretPosition});
                    }    
                    else{
                        // At this stage, tab and left/right arrows are handled only if not editing: editing cases are directly handled by LabelSlotsStructure.
                        // We start by getting from the DOM all the available caret and editable slot positions
                        this.appStore.leftRightKey({ key: event.key, isShiftKeyHold: event.shiftKey});
                    }
                    return;
                }

                const ignoreKeyEvent = this.appStore.ignoreKeyEvent;

                if(event.key != "Escape"){
                    if(!isEditing && !this.appStore.isAppMenuOpened && !isPythonExecuting && !isDraggingFrames){
                        // Cases when there is no editing:
                        const isHiddenShorthandFrameCommand = (hiddenShorthandFrames[eventKeyLowCase] !== undefined 
                            && Object.values(this.addFrameCommands).flat().flatMap((addFrameDef) => addFrameDef.type.type).includes(hiddenShorthandFrames[eventKeyLowCase].type.type));
                        if(!(event.ctrlKey || event.metaKey)){
                            if(event.key == "Delete" || event.key == "Backspace"){
                                if(!ignoreKeyEvent && !event.repeat){
                                    //delete a frame or a frame selection
                                    this.appStore.deleteFrames(event.key);
                                    event.stopImmediatePropagation();
                                }
                                else{
                                    this.appStore.ignoreKeyEvent = false;
                                }
                            }
                            //add the frame in the editor if allowed or the special cases of hidden frames
                            else if(this.addFrameCommands[eventKeyLowCase] !== undefined || Object.values(this.addFrameCommands).find((addFrameCmdDef) =>  addFrameCmdDef[0].shortcuts[1] == eventKeyLowCase) !== undefined
                                || isHiddenShorthandFrameCommand){
                                if(!ignoreKeyEvent){
                                    event.stopImmediatePropagation();
                                    event.stopPropagation(),
                                    event.preventDefault();
                                    if(isHiddenShorthandFrameCommand) {
                                        // Adding a shorthand frame required to 1) add the frame itself
                                        this.appStore.addFrameWithCommand(hiddenShorthandFrames[eventKeyLowCase].type, hiddenShorthandFrames[eventKeyLowCase]);
                                    }
                                    else{
                                        // We can add the frame by its original shortcut or hidden one
                                        const isOriginalShortcut = (this.addFrameCommands[eventKeyLowCase] != undefined);
                                        this.appStore.addFrameWithCommand(
                                            (isOriginalShortcut)
                                                ? this.addFrameCommands[eventKeyLowCase][0].type
                                                : (Object.values(this.addFrameCommands).find((addFrameCmdDef) =>  addFrameCmdDef[0].shortcuts[1] == eventKeyLowCase) as AddFrameCommandDef[])[0].type
                                        );
                                    }
                                }
                                else{
                                    this.appStore.ignoreKeyEvent = false;
                                }
                            }
                        }
                        else if(event.key == " " && this.appStore.selectedFrames.length == 0){
                            // If ctrl/meta + space is activated on caret, we add a new functional call frame and trigger the a/c
                            this.appStore.addFrameWithCommand(this.addFrameCommands[eventKeyLowCase][0].type);
                            this.$nextTick(() => document.activeElement?.dispatchEvent(new KeyboardEvent("keydown",{key: " ", ctrlKey: true})));
                        }
                    }
                    
                    else if(isPythonExecuting && !(this.$refs[getPEAComponentRefId()] as InstanceType<typeof PythonExecutionArea>).$data.isRunningStrypeGraphics){
                        // The special case when the user's code is being executing, we want to handle the key events carefully.
                        // If there is a combination key (ctrl,...) we just ignore the events, otherwise, if Turtle is active we pass events to the Turtle graphics,
                        // and if it's not active AND the Python Execution console hasn't go focus, we prevents events.
                        if(!event.altKey && !event.ctrlKey && !event.metaKey){
                            const turtlePlaceholder = document.getElementById(getPEAGraphicsDivId());
                            const isTurtleShowing = turtlePlaceholder?.style.display != "none";
                            if(turtlePlaceholder && isTurtleShowing && document.activeElement?.id != turtlePlaceholder.id){
                                // Give focus to the Turtle graphics first to make sure it will respond.
                                turtlePlaceholder.focus();
                                // Then we can forward the key event.
                                setTimeout(() => {
                                    turtlePlaceholder.dispatchEvent(new KeyboardEvent("keydown", {
                                        keyCode: event.keyCode,
                                    }));
                                    turtlePlaceholder.dispatchEvent(new KeyboardEvent("keyup", {
                                        key: event.key,
                                        keyCode: event.keyCode,
                                    }));
                                }, 500);
                            }

                            if(document.activeElement?.id === getPEAConsoleId()){
                                // Don't interfere with the Python Execution console if it's having focus
                                return;
                            }

                            event.stopImmediatePropagation();
                            event.stopPropagation(),
                            event.preventDefault();
                            return;
                        }
                    }
                    
                }
                else if(this.appStore.isDraggingFrame){
                    // Hitting escape during a DnD cancels it.
                    notifyDragEnded();
                }

                //prevent default browser behaviours when an add frame command key is typed (letters and spaces) (e.g. Firefox "search while typing")
                if(!isEditing && !this.appStore.isAppMenuOpened && !(event.ctrlKey || event.metaKey) && (event.key.match(/^[a-z A-Z=]$/) || event.key === "Backspace")){
                    event.preventDefault();
                    return;
                }
            }
        );

        document.addEventListener(CustomEventTypes.editorAddFrameCommandsUpdated, () => {
            // When the frame commands have been updated (i.e. language changed), we need to get this component to be re-rendered:
            // we use this reactive flag to trigger the recomputation of the computed property addFrameCommands
            this.frameCommandsReactiveFlag = !this.frameCommandsReactiveFlag;
        });
    },

    mounted() {
        //scroll events on the left pane (menu) and right pane (commands) are forwarded to the editor
        document.getElementById(getMenuLeftPaneUID())?.addEventListener(
            "wheel",
            this.handleAppScroll,
            false
        );

        document.getElementById(getCommandsRightPaneContainerId())?.addEventListener(
            "wheel",
            this.handleAppScroll,
            false
        );
    },

    methods: {
        addFrameCommandUID(commandType: string): string {
            return getAddFrameCmdElementUID(commandType);
        },
        
        handleAppScroll(event: WheelEvent) {
            // Don't do anything if a context menu is displayed 
            if(!getActiveContextMenu()){
                const currentScroll = $("#"+getEditorMiddleUID()).scrollTop();
                $("#"+getEditorMiddleUID()).scrollTop((currentScroll??0) + (event as WheelEvent).deltaY/2);
            }          
        },

        getLastProjectSavedDateTooltip() {
            // We show an indication about the last saved date of the document (unless there is no select source yet)
            if(this.isProjectNotSourced) {
                return "";
            }
            
            // There shouldn't be a case when we get a date that is no set to a proper value, but to prevent
            // weird and invalid date display, we associate the default value -1 to "unknown".
            if(this.appStore.projectLastSaveDate == -1){
                this.lastProjectSavedDateTooltip = this.$i18n.t("appMessage.lastSavedDateUnknown") as string;
                return;
            } 

            // The format of that indication depends on how long the last saved date was.
            // If it was within a week (that is, less than 24*7 hours ago), we show "last saved <xxx> ago",
            // otherwise, we show "last saved on <yyy>".
            let toolTipVal = "";
            const lastSaveDateTickDiff = Date.now() - this.appStore.projectLastSaveDate;
            if(lastSaveDateTickDiff > 604800000 ){
                // More than a week ago (7 days * 24 h * 60 min * 60 s * 1000 ms)
                toolTipVal = this.$i18n.t("appMessage.lastSavedOn", {lastSavedDate: new Date(this.appStore.projectLastSaveDate).toLocaleString()}) as string; 
            }
            else if(lastSaveDateTickDiff > 86400000){
                // Less than a week but more than a day ago (24 h * 60 min * 60 s * 1000 ms)
                const nbDays = lastSaveDateTickDiff / 86400000;
                toolTipVal = (nbDays > 1)
                    ? this.$i18n.t("appMessage.lastSavedOnNDays", {nbLastSave: Math.round(nbDays)}) as string
                    : this.$i18n.t("appMessage.lastSavedOn1Day") as string;
            }
            else if(lastSaveDateTickDiff > 3600000){
                // Less than a day but more than an hour ago (60 min * 60 s * 1000 ms)
                const nbHours = lastSaveDateTickDiff / 3600000;
                toolTipVal = (nbHours > 1)
                    ? this.$i18n.t("appMessage.lastSavedOnNHours", {nbLastSave: Math.round(nbHours)}) as string
                    : this.$i18n.t("appMessage.lastSavedOn1Hour") as string;
            }
            else if(lastSaveDateTickDiff > 60000){
                // Less than an hour but more than a minute ago (60 s * 1000 ms)
                const nbMins = lastSaveDateTickDiff / 60000;
                toolTipVal = (nbMins > 1)
                    ? this.$i18n.t("appMessage.lastSavedOnNMins", {nbLastSave: Math.round(nbMins)}) as string
                    : this.$i18n.t("appMessage.lastSavedOn1Min") as string;

            }
            else {
            // Less than a minute ago (we will use min 1 seconde even if less than a second, which is unlikely)
                const nbSecs = lastSaveDateTickDiff / 1000;
                toolTipVal = (nbSecs > 1)
                    ? this.$i18n.t("appMessage.lastSavedOnNSecs", {nbLastSave: Math.round(nbSecs)}) as string
                    : this.$i18n.t("appMessage.lastSavedOn1Sec") as string;
            }
            this.lastProjectSavedDateTooltip = toolTipVal;
        },

        

        
        onPEAMounted(){
            // Once the PEA is ready, we need to fix the splitter's position between the frame commands area and the PEA,
            // so that the PEA stays at the bottom of the viewport as intially intented (in its initial 4:3 ratio).
            const peaElement = (this.$refs[this.peaComponentRefId] as Vue).$el;
            const peaHeight = peaElement.getBoundingClientRect().height;
            const peaMargin = parseInt(scssVars.pythonExecutionAreaMargin.replace("px",""));
            // (The divider isn't exactly the size we give in CSS (I don't know why so we check it like that))
            const commandsSplitterDivider = document.querySelector("." + scssVars.commandsPEASplitterThemeClassName + " .splitpanes__splitter");
            if(commandsSplitterDivider){
                const commandsSplitterHeight = commandsSplitterDivider.getBoundingClientRect().height + parseInt(window.getComputedStyle(commandsSplitterDivider).marginTop.replace("px","")); 
                const viewPortH = document.getElementsByTagName("body")[0].getBoundingClientRect().height;
                this.commandsSplitterPane2Size = ((peaHeight + peaMargin ) * 100) / (viewPortH - commandsSplitterHeight);
                // The splitter's PEA pane's min size will be updated after computeAddFrameCommandContainerSize() is called
            }

            // Finally, also update the frame commands panel as it may now overflow...
            setTimeout(() => {
                computeAddFrameCommandContainerSize(); 
            }, 200);
        },

        resetPEACommmandsSplitterDefaultState(): Promise<void> {
            // When a project is loaded, a PEA layout will be affected.
            // We need to make sure to be "as if" we were starting from a default project layout
            // before doing anything (otherwise we have issues with some layout related stuff that
            // are not saved, or some styling that gets messy).
            return new Promise((resolve) => {
                this.hasPEAExpanded = false;
                this.isCommandsSplitterChanged = false;               
                (this.$refs[this.peaComponentRefId] as InstanceType<typeof PythonExecutionArea>).togglePEALayout(StrypePEALayoutMode.tabsCollapsed);
                // Once we have the flags set, we set a timer to wait for the splitter to update before returning from the promise
                setTimeout(() => {
                    resolve();
                }, 800);   
            });            
        },        

        onCommandsSplitterResize(event: any) {
            // When the splitter is resized, we need to resize the frame commands container (wrap/unwrap)
            // and the PEA (will take the full space in its pane, breaking the initial 4:3 ratio)
            document.getElementById(getPEATabContentContainerDivId())?.dispatchEvent(new CustomEvent(CustomEventTypes.pythonExecAreaSizeChanged));
            this.isCommandsSplitterChanged = true;
            this.commandsSplitterPane2Size = event[1].size;
            // We also save the value in the store. We do not want to set commandsSplitterPane2Size as get/set computed property
            // (and call the appStore change in set()) because we set the value based on other settings (the 4:3 ratio) when PEA is mounted,
            // that value then shouldn't be saved in the store.
            if(this.appStore.peaCommandsSplitterPane2Size != undefined){
                this.appStore.peaCommandsSplitterPane2Size[this.appStore.peaLayoutMode??StrypePEALayoutMode.tabsCollapsed] = this.commandsSplitterPane2Size;
            }
            else {
                // The tricky case of when the state property has never been set
                this.appStore.peaCommandsSplitterPane2Size = {...defaultEmptyStrypeLayoutDividerSettings, [this.appStore.peaLayoutMode??StrypePEALayoutMode.tabsCollapsed]: event[1].size};
            }
        }, 

        setPEACommandsSplitterPanesMinSize(onlyResizePEA?: boolean) {
            // Called to get the right min sizes of the pea/Commands splitter.
            // The minimum size the first pane of the splitter can take is set to guarantee
            // the project name is visible, and the first row of add frame commands + potential scrollbars.
            // The minimum size for the second pane of the splitter is a bit more deterministic: the header
            // of the PEA component + about 3 lines of text (we don't include the botton margin). 
            // Nevertheless, the min size need to change if the PEA component changes: in window resize events 
            // or when the editor/commands splitters pushes the commands too small.
            const viewPortH = document.getElementsByTagName("body")[0].getBoundingClientRect().height;
            const commandsSplitterDivider = document.querySelector("." + scssVars.commandsPEASplitterThemeClassName + " .splitpanes__splitter");
            if(commandsSplitterDivider) {               
                const commandsSplitterHeight = commandsSplitterDivider.getBoundingClientRect().height; 
                const projectNameContainerDiv = document.getElementsByClassName(scssVars.strypeProjectNameContainerClassName)?.[0];
                const firstAddCommandDiv = document.querySelector("." + scssVars.addFrameCommandsContainerClassName + " p > div");                
                // Pane 1: it is possible that at some point, the frame commands panel has a x-axis scroll bar (when the commands are wrapped). 
                // So we need to account for that in the min size.
                const frameCommandsContainer = (document.querySelector("." + scssVars.noPEACommandsClassName) as HTMLDivElement);
                const frameCommandsScrollBarH = frameCommandsContainer.offsetHeight - frameCommandsContainer.clientHeight;
                if(projectNameContainerDiv && firstAddCommandDiv){
                    const firstAddCommandDivFullHeight = firstAddCommandDiv.getBoundingClientRect().height + parseInt(window.getComputedStyle(firstAddCommandDiv).marginTop.replace("px","")) + parseInt(window.getComputedStyle(firstAddCommandDiv).marginBottom.replace("px",""));                    
                    this.commandSplitterPane1MinSize = ((projectNameContainerDiv.getBoundingClientRect().height + firstAddCommandDivFullHeight + frameCommandsScrollBarH) * 100) / (viewPortH - commandsSplitterHeight);
                    const currentPane1Size = parseFloat(((this.$refs.peaCommandsSplitterPane1Ref as InstanceType<typeof Pane>).$data as PaneData).style.height.replace("%",""));
                    if(currentPane1Size < this.commandSplitterPane1MinSize){
                        // Setting the min size doesn't mean that the current size will update to be valid. 
                        // So we do it ourselves. The reactivity doesn't seem to always work (some timing issue?)
                        // so we change the data of the Panes directly
                        setTimeout(() => {
                            this.commandsSplitterPane2Size = (100 - this.commandSplitterPane1MinSize);      
                            (this.$refs.peaCommandsSplitterPane1Ref as InstanceType<typeof Pane>).$data.style.height = this.commandSplitterPane1MinSize + "%";
                            (this.$refs.peaCommandsSplitterPane2Ref as InstanceType<typeof Pane>).$data.style.height = this.commandsSplitterPane2Size + "%";
                            // And trigger the Graphics to resize properly
                            document.getElementById(getPEATabContentContainerDivId())?.dispatchEvent(new CustomEvent(CustomEventTypes.pythonExecAreaSizeChanged, {detail: onlyResizePEA}));
                        }, 200);                        
                    }     
                }    
            
                // Pane 2:
                const peaHeaderHeight = (document?.getElementById(getPEAControlsDivId())?.getBoundingClientRect().height)??0;
                const peaConsoleElement = document.getElementById(getPEAConsoleId());
                if(peaConsoleElement){               
                    const peaConsoleLineH = parseFloat(window.getComputedStyle(peaConsoleElement).lineHeight.replace("px",""));
                    this.commandSplitterPane2MinSize = ((peaHeaderHeight + 3 * peaConsoleLineH) * 100) / (viewPortH - commandsSplitterHeight);
                    const currentPane2Size = parseFloat(((this.$refs.peaCommandsSplitterPane2Ref as InstanceType<typeof Pane>).$data as PaneData).style.height.replace("%",""));
                    if(currentPane2Size < this.commandSplitterPane2MinSize){
                        // Setting the min size doesn't mean that the current size will update to be valid. 
                        // So we do it ourselves. The reactivity doesn't seem to always work (some timing issue?)
                        // so we change the data of the Panes directly
                        setTimeout(() => {
                            this.commandsSplitterPane2Size = (this.commandSplitterPane2MinSize);      
                            (this.$refs.peaCommandsSplitterPane1Ref as InstanceType<typeof Pane>).$data.style.height = (100 - this.commandsSplitterPane2Size) + "%";
                            (this.$refs.peaCommandsSplitterPane2Ref as InstanceType<typeof Pane>).$data.style.height = this.commandsSplitterPane2Size + "%";
                        }, 200);                        
                    }     
                }
            }
        },
        
    },
});
